import { Component, Input, OnInit } from '@angular/core';

import { FlashMessage, Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';

@Component({
    selector: 'app-flash-messages-for',
    templateUrl: './flash-messages-for.component.html',
    styleUrls: ['./flash-messages-for.component.css']
})
export class FlashMessagesForComponent implements OnInit {
    @Input() context: string;
    private severity: Severity;

    constructor(private flashMessagesService: FlashMessagesService) {
    }

    get messages(): FlashMessage[] {
        return this.flashMessagesService.messagesFor(this.severity);
    }

    close(id: string): void {
        this.flashMessagesService.clear(id);
    }

    hasMessages(): boolean {
        return this.flashMessagesService.hasMessagesOf(this.severity);
    }

    ngOnInit(): void {
        if (this.context === 'danger') {
            this.severity = Severity.Danger;
        } else if (this.context === 'warning') {
            this.severity = Severity.Warning;
        } else if (this.context === 'success') {
            this.severity = Severity.Success;
        } else if (this.context === 'info') {
            this.severity = Severity.Info;
        } else {
            throw new Error('context must be one of "danger", "warning", "success" or "info"');
        }
    }
}
